<template>
<div>
<header class="navbar navbar-dark sticky-top bg-dark flex-md-nowrap p-0 shadow">
  <a class="navbar-brand col-md-3 col-lg-2 me-0 px-3" href="#"><i class="bi-bag-check-fill px-3"></i>PageCheckup</a>
  <button ref="toggleButton" class="navbar-toggler position-absolute d-md-none collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#sidebarMenu" aria-controls="sidebarMenu" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>
  <div class="w-100"></div>
  <!--   <input class="form-control form-control-dark w-100" type="text" placeholder="Filter results..." aria-label="Filter results..."> -->
  <div class="navbar-nav">
    <div class="nav-item text-nowrap">
      <a class="nav-link px-3" href="#"><i class="bi-bar-chart-fill px-3"></i>Upgrade Plan</a>
    </div>
  </div>
</header>

<div class="container-fluid">
  <div class="row">
    <nav ref="sidebarMenu" id="sidebarMenu" class="col-md-3 col-lg-2 d-md-block bg-light sidebar collapse">
      <div class="position-sticky pt-3">
        <ul class="nav flex-column">
          <li class="nav-item">
            <router-link @click="hideMenu" class="nav-link" :to="{name: crawlId ? 'createFromCrawl' : 'create', params: {crawlId}}" active-class="active" aria-current="page">
              <span data-feather="home"></span>
              Start New Scan
            </router-link>
          </li>
        </ul>
        <template v-if="crawlId">
        <h6 class="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted">
          <span>Scan Results</span>
          <a class="link-secondary" href="#" aria-label="Add a new report">
            <span data-feather="plus-circle"></span>
          </a>
        </h6>
        <ul class="nav flex-column mb-2">
          <li class="nav-item">
            <router-link @click="hideMenu" class="nav-link" :to="{name: 'pageResults'}" active-class="active">
              <span data-feather="file"></span>
              Pages Found ({{ scannedPageCount }})
            </router-link>
          </li>
          <li class="nav-item">
            <router-link @click="hideMenu" class="nav-link" :to="{name: 'productResults'}" active-class="active">
              <span data-feather="shopping-cart"></span>
              Products Found ({{ uniqueProductCount }})
            </router-link>
          </li>
        </ul>
        </template>
      </div>
    </nav>

    <main class="col-md-9 ms-sm-auto col-lg-10 px-md-4">
      <router-view :crawl-id="crawlId" :result-data="resultData" />
    </main>
  </div>
</div>
</div>
</template>

<script>
export default {
  props: ['crawlId', 'newCrawl'],
  data() {
    return {
      resultData: this.initialData()
    }
  },
  computed: {
    uniqueProductCount() {
      return this.filterUniqueProducts(this.resultData.amazonItems).length;
    },
    scannedPageCount() {
      if (! this.resultData || ! this.resultData.amazonItems) {
        return 0;
      }
      return this.resultData.amazonItems.length;
    }
  },
  methods: {
    hideMenu() {
      this.$refs.sidebarMenu.classList.remove('show')
    },
    initialData() {
      return {
        error: null,
        initialLinks: null,
        amazonItems: null,
        dataLoaded: false,
        dataComplete: false,
        outstandingRequestCount: null,
        completedRequestCount: null,
        shouldLoadData: true,
        loadingPercent: 0,
        startedLoading: false,
      }
    },
    filterUniqueProducts(inputItems) {
      if (! inputItems) {
        return [];
      }
      const filteredUniqueItems = {};
      for (const amazonItem of inputItems) {
        for (const metadataItem of amazonItem.uniqueMetadataList) {
          if (this.pageFilter && ! ('' + metadataItem.amazonMetadata.productTitle).toLowerCase().includes(this.pageFilter)) {
            continue;
          }

          if (! filteredUniqueItems[metadataItem.amazonMetadata.productPage]) {
            filteredUniqueItems[metadataItem.amazonMetadata.productPage] = metadataItem;
          } else {
            //console.log("Found => " + metadataItem.amazonMetadata.productPage);
          }
        }
      }
      return Object.values(filteredUniqueItems);
    },
    loadingPercent() {
      if (! this.resultData.completedRequestCount) {
        return 0;
      }

      return Math.floor(
        (this.resultData.completedRequestCount /
          (this.resultData.outstandingRequestCount + this.resultData.completedRequestCount)) *
          100
      );
    },
    async loadStatus(where, crawlId) {
      if (! crawlId) {
        console.log("No crawlId", where)
        return;
      }

      console.log("loadStatus from", where)

      this.resultData.startedLoading = true;

      const amazonResponse = await fetch(
        this.backendHost + "/amazon/" + crawlId
      );

      if (! amazonResponse.ok) {
        this.resultData.error = "Oops... something went wrong";
        return;
      }

      const statusResponse = await fetch(
        this.backendHost + "/status/" + crawlId
      );

      if (! statusResponse.ok) {
        this.resultData.error = "Oops... something went wrong";
        return;
      }

      const statusJson = await statusResponse.json();
      this.resultData.initialLinks = statusJson.initialLinks;

      const amazonJson = await amazonResponse.json();
      this.resultData.amazonItems = amazonJson.items;

      for (let i = 0; i < this.resultData.amazonItems.length; i++) {
        this.resultData.amazonItems[i].id = i;
      }

      this.resultData.dataLoaded = true;
      this.resultData.dataComplete =
        statusJson.crawlState &&
        (statusJson.crawlState.stateType === "LIMIT_REACHED" ||
          statusJson.crawlState.stateType === "COMPLETED");

      this.resultData.outstandingRequestCount = statusJson.outstandingRequestCount;
      this.resultData.completedRequestCount = statusJson.completedRequestCount;

      this.resultData.shouldLoadData  = ! this.resultData.dataLoaded || ! this.resultData.dataComplete;
      this.resultData.loadingPercent = this.loadingPercent();

      if (! this.resultData.shouldLoadData) {
        //console.log("Data is fully loaded");
        return;
      }
      setTimeout(() => {
        this.loadStatus(where, crawlId);
      }, 2000);
    }
  },
  watch: {
      '$route' (to, from) {
          if ((from.name === 'create' || from.name === 'createFromCrawl')
          && to.path.startsWith('/results/') && to.params.newCrawl) {
            this.resultData = this.initialData();
            //on route change re run: onCreated
            if (! this.startedLoading) {
              //console.log("Route watch (results)", to.params.crawlId, to, from)
              this.loadStatus('watcher', to.params.crawlId);
            }
          }
      }
  },
  mounted() {
    window.feather.replace({ 'aria-hidden': 'true' })
    this.loadStatus('mounted', this.crawlId);
  }
};
</script>
